/* ⛔ DECISION D'HICHAM DU 03/10/2026 (PD-22) : LES PUCES, AU CHOIX DE NAWAL.
 * « Il faudrait qu'elle ait l'option de le faire ou non. »
 * L'editeur de modules ne se touche pas (decision du 02/10) : il ecrit du texte
 * brut. L'option passe donc par ce que Nawal tape deja — releve de la base
 * locale le 03/10 : des lignes commencant par « - » (sequences 205, 5788,
 * 5928...) ou par « • » (5621, 5681), affichees telles quelles.
 * Une ligne qui commence par « - », « – » ou « • » suivi d'un espace devient une
 * puce dessinee comme la planche 06 ; sans ce signe, rien ne change.
 *
 * Ne touche PAS un texte qui contient deja du HTML, quel qu'il soit (<p>,
 * <ul>, <br>, <strong>... : contenus de l'ancien editeur) : une puce coupee au
 * milieu d'une balise en ligne donnerait un HTML mal imbrique.
 * Le texte n'est pas echappe : il est deja rendu comme du HTML, avant comme
 * apres (`EditableField`).
 */
/* L'espace apres le signe peut etre insecable (copie depuis un traitement de
   texte). */
const LIGNE_PUCE = /^[ \t\u00A0]*[-–•][ \t\u00A0]+(\S.*)$/
const HTML = /<\/?[a-z][^>]*>/i

export const avecPuces = (texte) => {
  if (typeof texte !== "string" || HTML.test(texte)) return texte
  const lignes = texte.split(/\r?\n/)
  if (!lignes.some((l) => LIGNE_PUCE.test(l))) return texte

  /* Blocs : du texte, ou une liste de puces consecutives. Les lignes vides qui
     touchent une liste sont absorbees : l'ecart vient de la liste elle-meme,
     comme entre deux paragraphes. */
  const blocs = []
  for (const l of lignes) {
    const m = l.match(LIGNE_PUCE)
    const dernier = blocs[blocs.length - 1]
    if (m) {
      if (dernier?.puces) dernier.puces.push(m[1].trim())
      else blocs.push({ puces: [m[1].trim()] })
    } else if (dernier && !dernier.puces) {
      dernier.lignes.push(l)
    } else {
      blocs.push({ lignes: [l] })
    }
  }
  const texteDe = (b) => b.lignes.join("\n").replace(/^\n+|\n+$/g, "")
  /* Une ligne vide entre deux puces ne coupe pas la liste en deux. */
  const utiles = []
  for (const b of blocs.filter((x) => x.puces || texteDe(x).trim() !== "")) {
    const dernier = utiles[utiles.length - 1]
    if (b.puces && dernier?.puces) dernier.puces.push(...b.puces)
    else utiles.push(b)
  }
  return utiles.map((b, i) => {
    if (!b.puces) return texteDe(b)
    const avant = i > 0 ? ' data-avant="texte"' : ""
    const apres = i < utiles.length - 1 ? ' data-apres="texte"' : ""
    return `<ul data-puces="oui"${avant}${apres}>${b.puces.map((p) => `<li>${p}</li>`).join("")}</ul>`
  }).join("")
}
